import React, { Component } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import {
  OAuthSignInButton,
  OAuthSignOutButton
} from 'components';
import styles from './styles';
import googleLogo from 'images/search.png';

class Login extends Component {
  icon = () => {
    return <img src={googleLogo} alt='Google' style={{ width: '15px', marginTop: '-6px' }}/>
  }

  render = () => {
    const { signedIn, classes } = this.props;

    return (
      signedIn ? (
        <OAuthSignOutButton>
          Sign Out
        </OAuthSignOutButton>
        ) : (
        <Card style={{ margin: '200px auto', width: '300px', textAlign: 'center' }}>
          <CardContent>
            <Typography variant="title" className={classes.title} color="inherit">
              Login
            </Typography>
            <OAuthSignInButton
              provider='google'
              icon={this.icon()}
              signInParams={{ prompt: 'consent' }}
            >
              Google
            </OAuthSignInButton>
          </CardContent>
        </Card>
        )
    );
  }
}

const mapStateToProps = (state) => {
  const signedIn = !!state.auth.getIn(['user', 'isSignedIn']);
  return { signedIn };
};

const component = connect(mapStateToProps)(Login);
export default withStyles(styles)(component);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js